export const SERVICE_HEALTH = {
  OPERATIONAL: 'operational',
  DEGRADED: 'degraded',
  DOWN: 'down'
}

class StatusModel {
  constructor() {
    this.health = SERVICE_HEALTH.DOWN
    // raw per-source status, kept for the tooltip/debugging
    this.sources = { gps: false, loads: false, dispatch: false, orpak: false }
  }

  /**
   * Classifies GET /fuel_levels/alerts into a 3-level health, from `reason`:
   * { gps, loads, dispatch (FMSDiesel), orpak (Fluidintel) }, each 1/0.
   *
   * - DOWN: both fuel sources (FMSDiesel and Fluidintel) are down — includes the
   *   case where every source is down, since that implies the fuel sources are too.
   * - OPERATIONAL: at least one fuel source is up, AND both GPS and loads are up.
   * - DEGRADED: at least one fuel source is up, but GPS or loads is down.
   */
  fromV1 = data => {
    const reason = data?.reason || {}
    this.sources = {
      gps: reason.gps === 1,
      loads: reason.loads === 1,
      dispatch: reason.dispatch === 1,
      orpak: reason.orpak === 1
    }

    const fuelOk = this.sources.dispatch || this.sources.orpak

    if (!fuelOk) {
      this.health = SERVICE_HEALTH.DOWN
    } else if (this.sources.gps && this.sources.loads) {
      this.health = SERVICE_HEALTH.OPERATIONAL
    } else {
      this.health = SERVICE_HEALTH.DEGRADED
    }

    return this
  }
}

export default StatusModel
